import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={27}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="m10.5 13.5-7-7-3 3 10 10L27 3l-3-3-13.5 13.5Z" fill={props.color} />
    </svg>
)

export default SvgComponent
